<div>

  <div class="top">
    <div class="floatR">

      <button *ngIf="hasPermission('manage_groups')" nz-button nzType="primary" nzShape="circle" (click)="showModal(false)">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
      </button>
    </div>
  
    <nz-form-item class="floatL" style="width: 50%;" *ngIf="showCompanyDD">
      <nz-form-label>Company</nz-form-label>
      <nz-select nzShowSearch nzAllowClear [(ngModel)]="selectedCompany" (ngModelChange)="getAssociatedCompanyInfo(); spinner = true" style="width: 100%;">
        <nz-option *ngFor="let c of companies" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
      </nz-select>
    </nz-form-item> 
  </div>
  
  <div style="padding: 20px;">
    <nz-input-group nzPrefixIcon="search">
      <input style="padding: 10px;" [(ngModel)]="searchValue" (keyup)="search()" type="text" nz-input placeholder="Search by name" />
    </nz-input-group>
  </div>
  
  <div>
    <nz-table #groupTable [nzData]="groupsList" [nzLoading]="spinner" nzShowSizeChanger>
      <thead>
        <tr>
          <th>Name</th>
          <th>Edit</th>
        </tr>
      </thead>
     <tbody>
       <tr  *ngFor="let g of groupTable.data">
         <td>{{ g.name }}</td>
         <td>
           <button *ngIf="hasPermission('manage_groups')" nz-button nzType="primary" nzShape="circle" (click)="showModal(g)">
             <span nz-icon nzType="edit" nzTheme="outline"></span>
           </button>
         </td>
       </tr>
     </tbody>
    </nz-table>
  </div>

</div>

<nz-modal [(nzVisible)]="addModal" nzTitle="Group" nzCentered (nzOnCancel)="cancelModal()" (nzOnOk)="saveModal()">
  <ng-container *nzModalContent>
    <form [formGroup]="groupForm">
      <nz-form-item>
        <nz-form-label nzRequired>Group Name</nz-form-label>
        <input nz-input formControlName="name" placeholder="Group 1" />
      </nz-form-item>

      <nz-form-item *ngIf="showCompanyDD">
        <nz-form-label nzRequired>Company</nz-form-label>
        <nz-select nzShowSearch nzAllowClear formControlName="company"  nzPlaceHolder="Select company">
          <nz-option *ngFor="let c of companies" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Users</nz-form-label>
        <div>Selected: {{groupForm.get('users')?.value?.length || 0}} users</div>
        <div>Available: {{users?.length || 0}} options</div>
        <nz-select 
          nzMode="multiple" 
          nzAllowClear 
          nzShowSearch 
          formControlName="users"
          nzPlaceHolder="Select users (optional)"
          style="width: 100%;">
          <nz-option 
            *ngFor="let u of users" 
            [nzLabel]="u.first_name + ' ' + u.last_name"
            [nzValue]="u.id">
          </nz-option>
        </nz-select>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
